import React from 'react';
import {
    StyledAppGalleryIcon,
    StyledAppStoreIcon,
    StyledGooglePlayIcon,
    StyledNashStoreIcon,
    StyledRuStoreIcon
} from './style/AppLinks.styled';

export const AppStoreLink = () => {
    return <StyledAppStoreIcon href="https://rttr2.zaycev.net/click?is=DoRZScPzEam47B3JwGZPUyHvCXOvGnP_J3dhodIGMm8jNFnh5vyWRVuqPKgaHeNhSQUdH8cPFgSBAKfGvndh7H8XKHqCY7NzzwGDk4BLbdgRVbjcEh48sLWbNKnpTndRNIbLei4vqGISyIZHZ6bVfaPcvjTfkBmzugvydFoCW_2EoorpFc6g-U70BbMYneXfGDSSow" />;
};

export const AppGalleryIcon = () => {
    return <StyledAppGalleryIcon href="https://appgallery.huawei.com/#/app/C101567849?appId=C101567849&source=appshare&subsource=C101567849" />;
};

export const GooglePlayIcon = () => {
    return <StyledGooglePlayIcon href="https://play.google.com/store/apps/details?id=free.zaycev.net&referrer=utm_source%3DSite%26utm_medium%3Dsite" />;
};

export const NashStoreIcon = () => {
    return <StyledNashStoreIcon href="https://store.nashstore.ru/store/6284bf240a39b25e4dd69071" />;
};

export const RuStoreIcon = () => {
    return <StyledRuStoreIcon href="https://apps.rustore.ru/app/free.zaycev.net" />;
};
